import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import ErrorIcon from 'apps/web_forms/assets/errorgraphic.svg';
import CloseIcon from 'apps/web_forms/assets/close.svg';
import SuccessIcon from 'apps/web_forms/assets/formicon.svg';
import RenderButtons from 'apps/web_forms/components/commons/RenderButtons';
import DMButton from './DMButton';

const StyledModal = styled.div`
  font-size: 13px; /* make sure ems within the component are sized the same no matter where it is included */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  z-index: 9999;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.open ? 1 : 0)};
  transition: opacity linear 0.25s;
  left: 0;
  top: 0;

  .error-box {
    position: relative;
    text-align: center;
    min-width: 30vw;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    background-color: white;
    padding: 15px;
    overflow-y: auto;
    max-height: 90vh;

    .close-button {
      position: absolute;
      text-align: right;
      width: auto;
      right: 15px;
      top: 0;
      font-size: 2.5em;
      cursor: pointer;
      opacity: 0.4;

      .close-icon {
        height: 0.5em;
        width: 0.5em;
      }
    }

    .error-icon {
      width: 60%;
      height: auto;
      display: inline-block;
      margin: 0 auto 15px;
      text-align: center;

      svg {
        display: inline-block;
        width: 120px;
        height: auto;
      }
    }

    .main-error-text {
      width: 100%;
      text-align: center;
      font-weight: bold;
      margin-bottom: 12px;
      font-size: ${(props) => (props.hasIcon ? '1.3em' : '2em')};
    }

    .help-tip {
      display: block;
      width: 100%;
      margin-bottom: 6px;
      text-align: center;
    }
    .final-message {
      width: 100%;
      text-align: center;
      padding: 4em;
    }
    .error-field {
      max-width: 300px;
      text-align: center;
      margin: 0 auto;
      color: #ff0000;
      overflow-wrap: break-word;
    }
  }
`;

const Buttons = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  gap: 15px;

  button {
    margin: 0;
  }
`;

// TODO: need some more aesthetic adjustments in here
const Modal = ({
  mainMessage,
  helpTip,
  isOpen,
  setIsOpen,
  icon,
  children,
  buttons,
  onClose,
  testId,
  isFullScreen,
  isFinal,
}) => {
  const closeModal = () => {
    if (onClose && typeof onClose === 'function') {
      onClose();
    }
    setIsOpen(false);
  };

  const hasChildren = children != null;
  const hasIcon = icon != null;

  return (
    <StyledModal
      open={isOpen}
      standard={!hasChildren}
      hasIcon={hasIcon}
      isFullScreen={isFullScreen}
      role='dialog'
    >
      <div className='error-box' data-testid={testId}>
        {!isFinal && (
          <span
            className='close-button'
            onClick={closeModal}
            role='button'
            aria-hidden='true'
            data-testid='modal-close-button'
          >
            <CloseIcon className='close-icon' />
          </span>
        )}
        {icon && (
          <div className='error-icon'>
            {icon === 'success' ? <SuccessIcon /> : <ErrorIcon />}
          </div>
        )}
        <div className='main-error-text'>{mainMessage}</div>
        {helpTip && <div className='help-tip'>{helpTip}</div>}
        {children}
        {isFinal ? (
          <div className='final-message'>You may close the tab</div>
        ) : (
          <Buttons>
            {buttons == null ? (
              <DMButton filled callbackMethod={closeModal}>
                Okay
              </DMButton>
            ) : (
              <RenderButtons buttons={buttons} />
            )}
          </Buttons>
        )}
      </div>
    </StyledModal>
  );
};

Modal.propTypes = {
  mainMessage: PropTypes.string,
  helpTip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  icon: PropTypes.string,
  children: PropTypes.node,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      filled: PropTypes.bool,
      materialText: PropTypes.bool,
      disabled: PropTypes.bool,
    })
  ),
  onClose: PropTypes.func,
  testId: PropTypes.string,
  isFullScreen: PropTypes.bool,
  isFinal: PropTypes.bool,
};

Modal.defaultProps = {
  mainMessage: '',
  helpTip: '',
  icon: undefined,
  children: undefined,
  buttons: undefined,
  onClose: () => {},
  testId: 'modal-box',
  isFullScreen: false,
  isFinal: false,
};

export default Modal;
